import { render, staticRenderFns } from "./SpecialPage.vue?vue&type=template&id=63e032ff&scoped=true&"
import script from "./SpecialPage.vue?vue&type=script&lang=js&"
export * from "./SpecialPage.vue?vue&type=script&lang=js&"
import style0 from "./SpecialPage.vue?vue&type=style&index=0&id=63e032ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e032ff",
  null
  
)

export default component.exports